import { IProductListMeta } from "@montana/models/generated/cms.interface";

export const calculateNextPageSize = (currentResultCount: number, listMeta: IProductListMeta): number => {
    if (currentResultCount >= listMeta.hits) {
        return 0;
    }

    return Math.min(listMeta.hits - (listMeta.currentPage + 1) * listMeta.pageSize, listMeta.pageSize)
};
